export default __webpack_public_path__ + "static/puzzle_image-3271dad0672296a9a28b7273321c5db3.png";